"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentScrollDisableTask = exports.CSS = exports.CSS_CLASS_NAME = exports.DOCUMENT_SCROLL_DISABLE = void 0;
var interface_1 = require("../../interface");
exports.DOCUMENT_SCROLL_DISABLE = 'DOCUMENT_SCROLL_DISABLE';
exports.CSS_CLASS_NAME = exports.DOCUMENT_SCROLL_DISABLE;
exports.CSS = "." + exports.CSS_CLASS_NAME + " { overflow: hidden; }";
var DocumentScrollDisableTask = /** @class */ (function () {
    function DocumentScrollDisableTask() {
        this.key = exports.DOCUMENT_SCROLL_DISABLE;
        this.version = 0;
    }
    DocumentScrollDisableTask.prototype.onRegister = function () {
        if (this.getSubscribersCount()) {
            this.disableScroll();
        }
    };
    DocumentScrollDisableTask.prototype.onSubscribe = function () {
        var count = this.getSubscribersCount();
        if (count === 1) {
            this.disableScroll();
        }
    };
    DocumentScrollDisableTask.prototype.onUnsubscribe = function () {
        var count = this.getSubscribersCount();
        if (!count) {
            this.enableScroll();
        }
    };
    DocumentScrollDisableTask.prototype.onDestroy = function () {
        this.enableScroll();
        /* istanbul ignore else */
        if (this.styleTag) {
            document.body.removeChild(this.styleTag);
        }
    };
    DocumentScrollDisableTask.prototype.disableScroll = function () {
        this.ensureStyleTag();
        document.documentElement.classList.toggle(exports.CSS_CLASS_NAME, true);
    };
    DocumentScrollDisableTask.prototype.enableScroll = function () {
        document.documentElement.classList.toggle(exports.CSS_CLASS_NAME, false);
    };
    DocumentScrollDisableTask.prototype.ensureStyleTag = function () {
        if (this.styleTag) {
            return;
        }
        var style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(exports.CSS));
        document.body.appendChild(style);
        this.styleTag = style;
    };
    DocumentScrollDisableTask.prototype.getSubscribersCount = function () {
        return (0, interface_1.getGlobalBehaviors)().getSubscribers(this.key).length;
    };
    return DocumentScrollDisableTask;
}());
exports.DocumentScrollDisableTask = DocumentScrollDisableTask;
//# sourceMappingURL=DocumentScrollDisableTask.js.map